// function to remove all "_" character from student_activity enum
export const removeUnderscore = (str: string) => {
	return str.replace(/_/g, ' ')
}
